import { useEffect } from "react";
import { useLocation } from "react-router";

const ScrollToTop = (props) => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }
    // Only the pathname, not the full location: a query-string-only change
    // (e.g. toggling a filter on /products, which replaces the URL to stay
    // shareable) shouldn't yank the page back to the top mid-scroll.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return <>{props.children}</>;
};

export default ScrollToTop;
